import moment from 'moment'

import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { PAYMENT_SCHEDULE_CHARGE_STATUS } from 'constants/payment'
import { sum } from 'lib/array/arrayUtils'

export function getMyGroupPaymentContribution(
  details: App.GroupPaymentDetails | undefined,
  customerId: string | undefined,
): App.GroupPaymentContributionDetails | undefined {
  if (!details || !customerId) {
    return undefined
  }

  return details.contributions.find(contribution => contribution.customerId === customerId)
}

export function getGroupPaymentContributionDueDate(
  contribution: App.GroupPaymentContributionDetails,
  paymentScheduleDetails: App.PaymentScheduleDetails | undefined,
): string | undefined {
  if (!contribution.paymentScheduleChargeId || !paymentScheduleDetails) {
    return undefined
  }

  return paymentScheduleDetails.charges.find(
    charge => charge.id === contribution.paymentScheduleChargeId,
  )?.dueDate
}

/**
 * Client-side mirror of svc-payment resolveContributionPayability for CTA UX only.
 * Backend re-checks when creating the payment plan.
 */
export function isGroupPaymentContributionPayable(
  contribution: App.GroupPaymentContributionDetails,
  paymentScheduleDetails: App.PaymentScheduleDetails | undefined,
): boolean {
  if (contribution.status !== 'pending') {
    return false
  }

  if (!contribution.paymentScheduleChargeId) {
    return false
  }

  const charge = paymentScheduleDetails?.charges.find(
    item => item.id === contribution.paymentScheduleChargeId,
  )

  if (!charge) {
    return false
  }

  if (charge.status !== PAYMENT_SCHEDULE_CHARGE_STATUS.PENDING) {
    return false
  }

  // Match charge-engine due-date gating: UTC calendar day + YYYY-MM-DD string compare.
  const today = moment.utc().format(ISO_DATE_FORMAT)
  if (today >= charge.dueDate) {
    return false
  }

  return true
}

export function getGroupPaymentTotalAmount(details: App.GroupPaymentDetails): number {
  return sum(
    details.contributions.filter(contribution => contribution.status !== 'cancelled'),
    contribution => contribution.amount,
  )
}
